var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"filters-container"},[_c('div',{staticClass:"filters-header"},[_vm._v("FILTER BY:")]),_c('div',{staticClass:"filter-options"},[_c('h5',[_vm._v("Category")]),_c('CategoryNav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }